import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/app/src/components/_ui/separator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarTrigger"] */ "/app/src/components/_ui/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/wiki/avatar/avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/wiki/edit-button/edit-button.tsx");
